export const formatCurrency = val => {
    if (val) {
      return new Intl.NumberFormat('en-IN', {currency: 'INR'}).format(val);
    } else {
      return 0;
    }
  };

  export const maskNumber = n => {
    if (n) {
      return (
        n.slice(0, 2) +
        n.slice(2, n.length - 2).replace(/\d/g, 'X') +
        n.slice(n.length - 2)
      );
    }
  };